import { render, staticRenderFns } from "./car_plate_field.vue?vue&type=template&id=51ab5d26&lang=pug&"
import script from "./car_plate_field.vue?vue&type=script&setup=true&lang=js&"
export * from "./car_plate_field.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./car_plate_field.vue?vue&type=style&index=0&id=51ab5d26&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports